module.exports = __webpack_public_path__ + "4b3c66b79a665580934b191dbc0d8324.svg";